module.exports = __webpack_public_path__ + "img/horizontal_3_6_3016.a27b8727.png";